import ActiveRecord from './active_record/base'

class UserTemplateWeek extends ActiveRecord {
	static tableName = 'userTemplateWeeks'
}

export default UserTemplateWeek
